import React, { type ComponentProps } from 'react';

import { type Color, Colors, type Variant, Variants } from './types';

import { BadgeContainer } from './styles';

type BadgeProps = {
    color?: Color;
    children: React.ReactNode;
    variant?: Variant;
    active?: boolean;
} & ComponentProps<typeof BadgeContainer>;

export const Badge = ({
    children,
    color = Colors.primary,
    variant = Variants.default,
    active = false,
    ...others
}: BadgeProps) => (
    <BadgeContainer $color={color} $variant={variant} $active={active} {...others}>
        {children}
    </BadgeContainer>
);
